import { cloneDeep } from "lodash";
import React, { useState } from "react";

import { TriangleAlert } from "lucide-react";

import { Button } from "@/design-system/components/Button/Button";
import {
  Dialog,
  DialogActionsWrapper,
} from "@/design-system/components/Dialog/Dialog";
import { EditableProject, ProjectCodeEval } from "../reducers/environments";
import { AdvancedSettingsContent } from "./AdvancedSettingsContent";

type ModalState = {
  title: string;
  placeholder: string;
  project: EditableProject;
  closeOnOverlay: boolean;
  addingNewProject?: boolean;
  error?: string;
  addingNewEnvironment?: boolean;
  onClose?: () => void;
  onSave: (updatedProject: EditableProject) => void;
};

export const AdvancedConfigProjectModal: React.FC<ModalState> = ({
  project,
  onSave,
  title,
  onClose,
  error,
}) => {
  const [newProjectState] = useState(cloneDeep(project));
  const [codeEval, setCodeEval] = useState<ProjectCodeEval>(
    project.codeEval ?? {},
  );

  const onConfirm = () => {
    newProjectState.codeEval = codeEval;
    onSave(newProjectState);
  };

  const handleOpenChange = (open: boolean) => {
    if (!open) onClose?.();
  };

  return (
    <Dialog
      open={true}
      onOpenChange={handleOpenChange}
      title={`${title} — ${project.name}`}
      contentProps={{ className: "w-[600px]" }}
    >
      <div className="flex flex-col gap-4">
        {error && (
          <div className="flex items-center gap-2 rounded bg-red-500 px-3 py-2 text-sm font-bold text-white">
            <TriangleAlert className="h-4 w-4 shrink-0 text-white" />
            {error}
          </div>
        )}

        <AdvancedSettingsContent
          codeEval={project.codeEval}
          onChange={setCodeEval}
        />

        <DialogActionsWrapper>
          <Button variant="outline" onClick={onClose}>
            Cancel
          </Button>
          <Button onClick={onConfirm}>Save</Button>
        </DialogActionsWrapper>
      </div>
    </Dialog>
  );
};
